module.exports = __webpack_public_path__ + "static/flags/GT-33cec20d8618b672078a0ec76082d318.gif";